import { ref } from 'vue';

const progress = ref(0);

export function useClinic3dProgress() {
  return {
    progress,
  };
}
